import claudeRoundedAssetUrl from "./app/renderer/assets/icons/agents/claude-rounded.png";
import codexRoundedAssetUrl from "./app/renderer/assets/icons/agents/codex-rounded.png";
import cursorColorfulAssetUrl from "./app/renderer/assets/icons/agents/cursor-colorful.png";
import cursorRoundedAssetUrl from "./app/renderer/assets/icons/agents/cursor-rounded.png";
import agentColorfulAssetUrl from "./app/renderer/assets/icons/agents/agent-colorful.png";
import manageAgentTuttiAssetUrl from "./app/renderer/assets/icons/agents/manage-agent-tutti.png";
import opencodeRoundedAssetUrl from "./app/renderer/assets/icons/agents/opencode-rounded.png";
import openclawRoundedAssetUrl from "./app/renderer/assets/icons/agents/openclaw-rounded.png";
import providerRailClaudeCodeColorfulAssetUrl from "./app/renderer/assets/icons/agents/provider-rail-claude-code-colorful.png";
import providerRailCodexColorfulAssetUrl from "./app/renderer/assets/icons/agents/provider-rail-codex-colorful.png";
import providerRailOpenCodeColorfulAssetUrl from "./app/renderer/assets/icons/agents/provider-rail-opencode-colorful.png";
import providerRailTuttiAssetUrl from "./app/renderer/assets/icons/agents/provider-rail-tutti.png";

export const manageAgentClaudeCodeUrl = claudeRoundedAssetUrl;
export const manageAgentCodexUrl = codexRoundedAssetUrl;
export const manageAgentCursorUrl = cursorRoundedAssetUrl;
export const manageAgentTuttiUrl = manageAgentTuttiAssetUrl;
export const manageAgentTuttiAgentUrl = manageAgentTuttiAssetUrl;
export const manageAgentOpenCodeUrl = opencodeRoundedAssetUrl;
export const manageAgentOpenclawUrl = openclawRoundedAssetUrl;
export const agentColorfulUrl = agentColorfulAssetUrl;
export const claudeRoundedUrl = claudeRoundedAssetUrl;
export const codexRoundedUrl = codexRoundedAssetUrl;
export const cursorColorfulUrl = cursorColorfulAssetUrl;
export const cursorRoundedUrl = cursorRoundedAssetUrl;
export const tuttiDocRoundedUrl = manageAgentTuttiAssetUrl;
export const tuttiAgentRoundedUrl = manageAgentTuttiAssetUrl;
export const opencodeRoundedUrl = opencodeRoundedAssetUrl;
export const openclawRoundedUrl = openclawRoundedAssetUrl;
export const providerRailClaudeCodeColorfulUrl =
  providerRailClaudeCodeColorfulAssetUrl;
export const providerRailCodexColorfulUrl = providerRailCodexColorfulAssetUrl;
export const providerRailOpenCodeColorfulUrl =
  providerRailOpenCodeColorfulAssetUrl;
export const providerRailTuttiUrl = providerRailTuttiAssetUrl;
